<a [href]="isWindows && protocolLink || hrefLink" [class]="aClass" [style]="aStyle"
  [attr.target]="isWindows && protocolLink ? undefined : target"
>
  <ng-content></ng-content>
</a>
